import { IBotDetail, IBotSetting, Intent } from 'interface';
import { ChatbotContext } from 'providers/ChatbotProvider';
import { useContext, useMemo } from 'react';

const candidateStatuses = ['marked for deletion', 'marked for updated', 'trained'];

const useQuickActions = ({ botDetail }) => {
    const { isGeneralQuerySelected } = useContext(ChatbotContext);
    const { botSettings } = botDetail as IBotDetail;
    const { knowledgeSourceActionLabel: generalQueryAction } = botSettings as IBotSetting;

    const isKnowledgeSourcePresent = botDetail.websites.length > 0 || botDetail.documents.length > 0;

    const quickActions = useMemo(() => {
        const { apis } = botDetail;

        const filterIntentsByStatus = (intent: Intent) => {
            const { intentDetail, status } = intent;
            return intentDetail.enableStaticActionButton && candidateStatuses.includes(status.toLowerCase());
        };

        const getIntentName = (intent: Intent) => {
            const { intentDetail } = intent;
            return intentDetail.name;
        };

        const intentQuickActions = apis.filter(filterIntentsByStatus).map(getIntentName);

        if (!isGeneralQuerySelected && isKnowledgeSourcePresent) {
            return [generalQueryAction].concat(intentQuickActions);
        }

        return intentQuickActions;
    }, [botDetail, isGeneralQuerySelected, isKnowledgeSourcePresent, generalQueryAction]);

    return { quickActions };
};

export default useQuickActions;
